import {
  toDataSourceRequestString,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";
import {
  defaultAlertMessages,
  getConfirmErrorMessage,
  getConfirmSuccessMessage,
} from "../../utils/common";
import { confirmAlert } from "react-confirm-alert";

class TemplateService {
  getList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/mailtemplate/get-list`)
      .then((response) => {
        return response.data;
      });
  }

  getFilterList(dataState, callback) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/mailtemplate/get-list-by-filter?${toDataSourceRequestString(
          dataState
        )}`
      )
      .then((response) => {
        if (callback) callback(response.data);
        return dataState.group && dataState.group.length
          ? translateDataSourceResultGroups(response.data)
          : { data: response.data, dataState };
      });
  }

  getTemplate(id) {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/mailtemplate/get-by-id/${id}`)
      .then((response) => {
        return response.data;
      });
  }

  upsertTemplate(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/mailtemplate/upsert`, { ...data })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }
}

export default new TemplateService();
